import React from 'react'

import Flex from '../../../../../../components/layouts/Flex'
import DashboardInput from '../../../../../../components/dashboard/DashboardInput'
import DashboardPhoneInput from '../../../../../../components/dashboard/DashboardPhoneInput'

import { Button } from '../../../../../../components/Button'

const CharacterReferenceForm = ({
  characterReference,
  onChange,
  showForm,
  onClose,
  onAddCharacterReference,
  isEdit,
  fieldErrors,
}) => {
  return (
    <>
      {showForm && (
        <>
          <Flex gap="1rem">
            <DashboardInput
              errorMessage={fieldErrors?.name}
              name="name"
              label="Name *"
              placeholder="Enter Name"
              type="text"
              height="2.5rem"
              value={characterReference?.name}
              handleChange={(e) => onChange('name', e.target.value)}
            />
          </Flex>
          <Flex gap="1rem">
            <DashboardInput
              errorMessage={fieldErrors?.email}
              name="email"
              label="Email *"
              placeholder="Enter Email"
              type="text"
              height="2.5rem"
              value={characterReference?.email}
              handleChange={(e) => onChange('email', e.target.value)}
            />
          </Flex>
          <Flex>
            <DashboardPhoneInput
              errorMessage={fieldErrors?.phone}
              name="phone"
              label="Contact Number"
              placeholder=""
              type="text"
              height="2.5rem"
              value={characterReference?.phone}
              handleChange={(e) => onChange('phone', e)}
            />
          </Flex>
        </>
      )}
      <Flex margin="1rem 0 0 0" gap="1rem">
        <Button
          fontSize="0.875rem"
          height="35px"
          bgColor="#41ba80"
          width="50%"
          handleClick={onAddCharacterReference}
        >
          {showForm ? (isEdit ? 'Update' : 'Save') : 'Add Character Reference'}
        </Button>
        {showForm && (
          <Button
            fontSize="0.875rem"
            height="35px"
            bgColor="#dc2929"
            width="50%"
            handleClick={onClose}
          >
            Close
          </Button>
        )}
      </Flex>
    </>
  )
}

export default CharacterReferenceForm
